
import React from 'react';
import { motion } from 'framer-motion';

const categories = [
  {
    icon: "🕯️",
    title: "Декор",
    description: "Оформление мероприятий"
  },
  {
    icon: "🎁",
    title: "Подарки",
    description: "Индивидуальные наборы"
  },
  {
    icon: "✨",
    title: "Интерьер",
    description: "Для дома и офиса"
  },
  {
    icon: "🌟",
    title: "Свечи",
    description: "Уникальные коллекции"
  }
];

const Portfolio = () => {
  return (
    <section className="py-24 bg-wax-50">
      <div className="container px-4">
        <h2 className="font-cormorant-garamond text-4xl font-bold text-center mb-16">
          Наше портфолио
        </h2>
        <div className="grid md:grid-cols-4 gap-8">
          {categories.map((category, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all text-center cursor-pointer"
            >
              <span className="text-4xl mb-4 block">{category.icon}</span>
              <h3 className="text-xl font-bold mb-2">{category.title}</h3>
              <p className="text-gray-600">{category.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
